// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__270Hi","search":"Settings_search__2Nor-","filter":"Settings_filter__Z7UoQ"};